import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

const LecMenu = () => {
  const {t} = useTranslation()
  const location = useLocation()

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/lec/my-profile',
      icon: 'fas fa-user',
      color: '#0d6efd',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/lec/my-courses',
      icon: 'fas fa-book-open',
      color: '#22c55e',
    },
    {
      title: t('MENU.PUBLICATIONS'),
      to: '/lec/publications-list',
      icon: 'fas fa-book',
      color: '#f59e0b',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/lec/meetings',
      icon: 'fas fa-handshake',
      color: '#f43f5e',
    },
    {
      title: t('MENU.REGULATIONS'),
      to: '/lec/regulations',
      icon: 'fas fa-gavel',
      color: '#0ea5e9',
    },
    {
      title: t('LABEL.FEEDBACK'),
      to: '/lec/feedback',
      icon: 'fas fa-comments',
      color: '#0d6efd',
    },
    {
      title: t('LABEL.PEER_EVALUATION'),
      to: '/lec/peer-evaluations',
      icon: 'fas fa-user-friends',
      color: '#64748b',
    },
    {
      title: t('LABEL.NEWS'),
      to: '/lec/news-list',
      icon: 'fas fa-bullhorn',
      color: '#334155',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/lec/chat-room',
      icon: 'fas fa-comment-dots',
      color: '#22c55e',
    },
  ]

  const isMenuActive = (to?: string) => {
    if (!to) return false

    return location.pathname === to || location.pathname.startsWith(`${to}/`)
  }

  const renderMenu = (menu: any) => {
    const active = isMenuActive(menu.to)

    return (
      <div
        className={`compact-menu-item px-2 ${active ? 'active-menu-item' : ''}`}
        style={
          active
            ? {
                backgroundColor: '#f1f7ff',
                borderColor: '#d6e6ff',
              }
            : {
                backgroundColor: '#ffffff',
                borderColor: '#e5e7eb',
              }
        }
      >
        <div className='compact-icon'>
          <i
            className={`${menu.icon}`}
            style={{
              color: active ? '#0d6efd' : menu.color,
            }}
          ></i>
        </div>

        <div className='menu-text'>
          <span
            className='menu-title'
            style={{
              color: active ? '#0d6efd' : '#334155',
            }}
          >
            {menu.title}
          </span>
        </div>

        <div className='menu-shine'></div>
      </div>
    )
  }

  return (
    <div className='modern-compact-menu'>
      <div className='menu-container'>
        {menus.map((menu, index) => (
          <MenuItem key={index} to={menu.to} title={renderMenu(menu)} />
        ))}
      </div>

      <style>{`
        .modern-compact-menu {
          width: 100%;
          font-family: 'Inter', 'Poppins', system-ui, sans-serif;
        }

        .menu-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        }

        .compact-menu-item {
          position: relative;
          min-height: 45px;
          padding: 3px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          transition: all 0.25s ease;
          overflow: hidden;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
        }

        .compact-menu-item:hover {
          transform: translateY(-2px);
          background: #f8fbff !important;
          border-color: #cfe2ff !important;
          box-shadow: 0 8px 20px rgba(13, 110, 253, 0.12);
        }

        .active-menu-item {
          background: #f1f7ff !important;
          border-color: #d6e6ff !important;
          box-shadow: 0 8px 22px rgba(13, 110, 253, 0.14);
        }

        .active-menu-item::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 4px;
          background: #0d6efd;
          border-radius: 4px 4px 0 0;
        }

        .compact-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.25s ease;
        }

        .compact-icon i {
          font-size: 20px !important;
        }

        .compact-menu-item:hover .compact-icon {
          transform: scale(1.08);
        }

        .menu-text {
          display: flex;
          align-items: center;
        }

        .menu-title {
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.2px;
          white-space: nowrap;
        }

        .menu-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.5),
            transparent
          );
          transition: left 0.6s ease;
          pointer-events: none;
        }

        .compact-menu-item:hover .menu-shine {
          left: 100%;
        }

        @media (max-width: 900px) {
          .menu-container {
            gap: 5px;
          }

          .compact-menu-item {
            min-height: 30px;
            padding: 5px 5px;
            gap: 2px;
          }

          .compact-icon i {
            font-size: 18px !important;
          }

          .menu-title {
            font-size: 13px;
          }
        }

        @media (max-width: 680px) {
          .menu-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .compact-menu-item {
            justify-content: center;
          }

          .dropdown-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .compact-menu-item {
            min-height: 48px;
            padding: 9px 12px;
            gap: 8px;
          }

          .compact-icon i {
            font-size: 16px !important;
          }

          .menu-title {
            font-size: 12px;
          }

          .dropdown-card {
            padding: 11px 14px;
          }

          .dropdown-icon-wrapper i {
            font-size: 18px !important;
          }

          .dropdown-title {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  )
}

export default LecMenu
